import formatJq from './jqueryV2'
/**
 * Created by leiqr on 2015/6/8.
 * 运营中心首页
 */
require('../solution/css/animate.css');

define((require, exports, module) => {
    const $ = require('jquery');
    formatJq($)
    const template = require('art-template/dist/template');
    require('jqueryPagination');
    const detailIframeTpl = require('./detail_iframe_tpl');
    const tip = require('./tip');
    require('./top');
    require('./nav');

    const api_prefix = "http://120.24.100.98:9999/"; //api前缀
    const api_prefix1 = `${api_domain}/api/index.php?r=cms/`; //api前缀
    var main = {
        init() {
            const me = this;
            //$(".radio-list").css('display', 'none');
            const today = new Date();
            this.showloginName();

            function getUrl(today) {
                return `http://jira.mysoft.com.cn/issues/?jql=project = YKCPXQ AND fixVersion = ${today.getFullYear()}年${today.getMonth() + 1}月需求 ORDER BY cf[10235] DESC, priority DESC`;
            }

            //获取当月需求链接
            $("#cur_month").attr('href', getUrl(today));
            //获取下月需求链接
            today.setMonth(today.getMonth() + 1);
            $("#next_month").attr('href', getUrl(today));
            if (location.pathname === '/log/product_updates_log.html') {
                //获取云客产品更新日志
                main.releaseProjectLogSearch();
            } else {
                //需求进展列表数据
                main.unreleaseProjectLogSearch();
            }
            main.createSearch();
            main.getProdList();
            main.bindEvents();
        },
        showloginName() {
            const self = this;
            this.getloginName()
                .then((res) => {
                    if (res.inside) {
                        $(".project-content").css('display', 'block');
                        $(".jira-warpper").css('display', 'block');
                    }
                })
        },
        getloginName() {
            const url = `${api_prefix1}cms-search/login-info&jsonp=jsonp_data&_=1460643145754`;
            const defer = $.Deferred();
            $.getScript(url, () => {
                defer.resolve(window[jsopName]);
            });
            return defer.promise();
        },
        bindEvents() {
            //模拟点击事件切换更新墙
            //$("#radio1").on("click", function () {
            //    $(".project-content-out").css("display", "none");
            //    $(".jira-warpper").css("display", "block");
            //    $(".project-content").css("display", "block");
            //});
            ////模拟点击事件切换更新墙
            //$("#radio2").on("click", function () {
            //    $(".project-content").css("display", "none");
            //    $(".jira-warpper").css("display", "none");
            //    $(".project-content-out").css("display", "block");
            //})

            $(".project-list").on('mouseenter', 'p a span.project-name', function () {
                if ($.trim($(this).find(".desc-box").text())) {
                    $(this).find(".desc-box").show();
                }
            }).on('mouseleave', 'p a span.project-name', function () {
                $(this).find(".desc-box").fadeOut(100);
                clearSelectedState();
            }).on('click', 'p a', function (e) {
                const url = $(this).data("url");
                if (url) {
                    window.open(url);
                }
            })
.on('click', 'p a span.project-name em', (e) => {
                e.stopPropagation();
            });

            $(document).on('click', '.log-search-btn', (e) => {
                if (location.pathname === '/log/product_updates_log.html') {
                    main.releaseProjectLogSearch($('#log-select').val(), $('#log-keyword').val(), 1, 20);
                } else {
                    main.unreleaseProjectLogSearch($('#log-select').val(), $('#log-keyword').val(), 1, 20);
                }
            }).on('keydown', '#log-keyword', (e) => {
                if (e.keyCode === 13) {
                    $('.log-search-btn').click();
                }
            }).on('change', '#log-select', (e) => {
                main.curpage = 0;
                $('#log-keyword')[0] && $('#log-keyword')[0].focus();
                $('.log-search-btn').click();
            });

            $('#navbar').click((e) => {
                const target = $(e.target);
                const aid = target.data('aid') || target.parent().data('aid');
                if (aid !== undefined) {
                    const pid = target.data('pid') || target.parent().data('pid');
                    location.href = `/list.html?dirId=${aid}&pid=${pid}`;
                }
            });

            function clearSelectedState() {
                "getSelection" in window
                    ? window.getSelection().removeAllRanges()
                    : document.selection.empty();
            }
        },
        /**
         * 云客产品更新日志
         * @param pageIndex
         * @param pageSize
         * @returns {JQueryPromise<T>}
         */
        getReleaseProject(pageIndex, pageSize) {
            pageSize = pageSize || 20;
            const setting = {
                type: "get",
                url: `${api_prefix}redmine.php?m=getReleaseProject`,
                dataType: "jsonp",
                jsonp: "callback",
                data: { pageIndex, pageSize },
                success(res) {
                    const retCode = res.retCode;
                    if (retCode == 0) {
                        $('#Readmin_list').html(template('Readmin_template', { ReadminList: res.data.items }));
                        main.createPaging(res.data.total, pageSize, (index) => {
                            main.getReleaseProject(index + 1)
                        });
                    } else {
                        tip.showError(res.errMsg);
                    }
                },
                error() {
                    tip.showError("系统错误，请稍后再试");
                }
            };
            return $.ajax(setting);

        },
        /**
         * 需求进展列表数据
         * @param pageIndex
         * @param pageSize
         * @returns {JQueryPromise<T>}
         */
        getUnreleaseProject(pageIndex, pageSize) {
            pageSize = pageSize || 20;
            const setting = {
                type: "get",
                url: `${api_prefix}redmine.php?m=getUnreleaseProject`,
                dataType: "jsonp",
                jsonp: "callback",
                data: { pageIndex, pageSize },
                success(res) {
                    const retCode = res.retCode;
                    if (retCode == 0) {
                        $('#Readmin_list').html(template('Readmin_template', { ReadminList: res.data.items }));
                        main.createPaging(res.data.total, pageSize, (index) => {
                            main.getUnreleaseProject(index + 1)
                        });
                    } else {
                        tip.showError(res.errMsg);
                    }
                },
                error() {
                    tip.showError("系统错误，请稍后再试");
                }
            };
            $.ajax(setting);
        },
        /**
         * 需求进展列表数据分页
         * @param len 列表记录总数
         * @returns {JQueryPromise<T>}
         */
        createPaging(len, pageSize, callback) {
            const self = this;
            $("#pagination").pagination(len, {
                num_edge_entries: 1, //边缘页数
                num_display_entries: 4, //主体页数
                current_page: self.curpage,
                callback(index) {
                    self.curpage = index - 1;
                    callback && callback(self.curpage);
                },
                items_per_page: pageSize, //每页显示1项
                prev_text: "前一页",
                next_text: "后一页"
            });
        },
        createSearch(data) {
            $('.log-search').html(template('log_search_template', data || { prods: [] }));
        },
        getProdList() {
            return main.getJsonp("redmine.php?m=getProdList", (res) => {
                const retCode = res.retCode;
                if (retCode == 0) {
                    main.createSearch({ prods: res.data });
                } else {
                    tip.showError(res.errMsg);
                }
            });
        },
        releaseProjectLogSearch(prodId, keyword, pageIndex, pageSize) {
            pageSize = pageSize || 20;
            return main.getJsonp("redmine.php?m=getReleaseProject", (res) => {
                const retCode = res.retCode;
                if (retCode == 0) {
                    $('#Readmin_list').html(template('Readmin_template', { ReadminList: res.data.items }));
                    main.createPaging(res.data.total, pageSize, (index) => {
                        main.releaseProjectLogSearch(prodId, keyword, index + 1)
                    });
                } else {
                    tip.showError(res.errMsg);
                }
            }, {
 pageIndex: pageIndex || 1, pageSize, keyword, prodId 
});
        },
        unreleaseProjectLogSearch(prodId, keyword, pageIndex, pageSize) {
            pageSize = pageSize || 20;
            return main.getJsonp("redmine.php?m=getUnreleaseProject", (res) => {
                const retCode = res.retCode;
                if (retCode == 0) {
                    $('#Readmin_list').html(template('Readmin_template', { ReadminList: res.data.items }));
                    main.createPaging(res.data.total, pageSize, (index) => {
                        main.unreleaseProjectLogSearch(prodId, keyword, index + 1)
                    });
                } else {
                    tip.showError(res.errMsg);
                }
            }, {
 pageIndex: pageIndex || 1, pageSize, keyword, prodId 
});
        },
        getJsonp(url, success, data) {
            return $.ajax({
                type: "get",
                url: api_prefix + url,
                dataType: "jsonp",
                jsonp: "callback",
                data,
                success(res) {
                    if (typeof success === 'function') {
                        success(res)
                    }
                },
                error() {
                    tip.showError("系统错误，请稍后再试");
                }
            });
        }
    };

    const outside = {
        init(inside) {

            const prods = {
                prods: [{
                    prodId: '',
                    prodName: '全部产品'
                }, {
                    prodId: '100006',
                    prodName: '来访登记'
                }, {
                    prodId: '100027',
                    prodName: '智能话机'
                }, {
                    prodId: '99997',
                    prodName: '移动销售'
                }, {
                    prodId: '100007',
                    prodName: '渠道管家'
                }, {
                    prodId: '99999',
                    prodName: '云行销'
                }, {
                    prodId: '100017',
                    prodName: '渠道风控'
                }, {
                    prodId: '100029',
                    prodName: 'AI云店'
                }, {
                    prodId: '100010',
                    prodName: '云会员'
                }, {
                    prodId: '100011',
                    prodName: '活动中心'
                }, {
                    prodId: '100012',
                    prodName: '现场开盘'
                }, {
                    prodId: '100018',
                    prodName: '在线开盘'
                }, {
                    prodId: '100026',
                    prodName: '智能收款'
                }, {
                    prodId: '100016',
                    prodName: '在线销讲'
                }, {
                    prodId: '100030',
                    prodName: '案场销讲'
                }, {
                    prodId: '100022',
                    prodName: '意向登记'
                }, {
                    prodId: '100024',
                    prodName: '企微助手'
                }, {
                    prodId: '99990',
                    prodName: '公共'
                }, {
                    prodId: '99991',
                    prodName: '秒杀活动'
                }, {
                    prodId: '99992',
                    prodName: '认筹理财'
                }, {
                    prodId: '99993',
                    prodName: '微楼书（新版）'
                }, {
                    prodId: '99994',
                    prodName: '微楼书'
                }, {
                    prodId: '99995',
                    prodName: '全民营销'
                }, {
                    prodId: '99996',
                    prodName: '小蜜蜂'
                }, {
                    prodId: '99998',
                    prodName: '云call客'
                }, {
                    prodId: '100008',
                    prodName: '在线验资'
                }, {
                    prodId: '100009',
                    prodName: '移动交易'
                }, {
                    prodId: '100013',
                    prodName: '数字展厅'
                }, {
                    prodId: '100014',
                    prodName: '凡科活动服务'
                }, {
                    prodId: '100015',
                    prodName: '人脸识别'
                }, {
                    prodId: '100019',
                    prodName: '到访传播'
                }, {
                    prodId: '100020',
                    prodName: '传播监控'
                }, {
                    prodId: '100021',
                    prodName: '营销大屏'
                }, {
                    prodId: '100023',
                    prodName: '营销自动化'
                }, {
                    prodId: '100025',
                    prodName: '客流分析'
                }, {
                    prodId: '100028',
                    prodName: '新产品发布'
                }]
            };

            const pageSize = 10;

            const jsopName = 'jsonp_data';

            let curpage = 0;

            const sort_data = ['name', 'modified_time'];
            const sort_type = ['desc', 'asc'];

            const sortArray = [{
                sortData: sort_data[1],
                sortType: sort_type[1]
            }, {
                sortData: sort_data[0],
                sortType: sort_type[0]
            }];


            //更新说明文章列表
            function fetchUpdateList(pageIndex, appId, keyword) {
                const url = `${api_prefix1}cms-search/update-list&jsonp=${jsopName}&app_id=${appId || ''}&keyword=${keyword || ''}&page=${pageIndex}&limit=${pageSize}&sort_data_first=${sortArray[0].sortData}&sort_type_first=${sortArray[0].sortType}&sort_data_second=${sortArray[1].sortData}&sort_type_second=${sortArray[1].sortType}`;
                const defer = $.Deferred();
                $.getScript(url, () => {
                    defer.resolve(window[jsopName]);
                });
                return defer.promise();
            }

            //更新说明更新浏览量接口
            function updateScan(id) {
                const url = `${api_prefix1}cms-search/update-scan&jsonp=${jsopName}&id=${id || ''}&from=${inside ? 'yyzx' : 'yk'}`;
                const defer = $.Deferred();
                $.getScript(url, () => {
                    defer.resolve(window[jsopName]);
                });
                return defer.promise();
            }

            //.获取文章详情
            function getArticleInfo(id) {
                const url = `${api_prefix1}cms-search/get-update-article-info&jsonp=${jsopName}&id=${id || ''}`;
                const defer = $.Deferred();
                $.getScript(url, () => {
                    defer.resolve(window[jsopName]);
                });
                return defer.promise();
            }

            //文章详情的上一篇/下一篇
            function nextPrevArticle(id) {
                const url = `${api_prefix1}cms-search/update-next-prev&jsonp=${jsopName}&id=${id || ''}`;
                const defer = $.Deferred();
                $.getScript(url, () => {
                    defer.resolve(window[jsopName]);
                });
                return defer.promise();
            }

            function createPaging(count, pageSize, callback) {
                $("#pagination_outside").pagination(count, {
                    num_edge_entries: 1, //边缘页数
                    num_display_entries: 4, //主体页数
                    current_page: curpage,
                    callback(index) {
                        curpage = index - 1;
                        callback && callback(curpage);
                    },
                    items_per_page: pageSize, //每页显示1项
                    prev_text: "前一页",
                    next_text: "后一页"
                });
            }

            function createSearch(prods) {
                $('.log-search').html(template('log_search_template', prods));
            }

            function createLogs(logs) {
                $('.table-responsive tbody').html(template('logs_template', logs));

            }

            function search() {

                curpage = 0;
                fetchUpdateList(curpage, $('#log-select').val(), $('#log-keyword').val()).then((res) => {

                    createLogs(res);

                    createPaging(res.count, pageSize, (index) => {
                        fetchUpdateList(index, $('#log-select').val(), $('#log-keyword').val())
                            .then((res) => {
                                createLogs(res);
                            })
                    });

                });
            }

            function sortClick() {

                for (let i = 0, len = sortArray.length; i < len; i++) {
                    const $el = $(`[data-sort-data=${sortArray[i].sortData}]`);
                    $el.find('.sort_down').css('display', sortArray[i].sortType == sort_type[0] ? 'inline-block' : 'none');
                    $el.find('.sort_up').css('display', sortArray[i].sortType == sort_type[0] ? 'none' : 'inline-block');
                }

                search();

            }

            function eventInit() {
                $(document)
                    .on('click', '.sort-link-wrapper', (event) => {

                        const $target = $(event.currentTarget);

                        const sortData = $target.data('sort-data');
                        if (sortData == sortArray[0].sortData) {
                            sortArray[0].sortType = sort_type[+!$.inArray(sortArray[0].sortType, sort_type)];
                        } else if (sortData == sortArray[1].sortData) {
                            sortArray[1].sortType = sort_type[+!$.inArray(sortArray[1].sortType, sort_type)];
                            sortArray.reverse();
                        }

                        sortClick(sortArray);

                    })
                    .on('change', '#log-select', () => {
                        $('#log-keyword')[0] && $('#log-keyword')[0].focus();
                        search();
                    })
                    .on('keyup', '#log-keyword', (event) => {
                        if (event.keyCode == 13) {
                            search();
                        }
                    })
                    .on('click', '.log-search-btn', (event) => {
                        search();
                    })
                    .on('click', '.log_title', (event) => {
                        const target = $(event.target);
                        const id = target.data('id') || target.parent().data('id');
                        location.href = `./log_detail.html?aid=${id}`;
                    })
                    .on('click', '#navbar', (event) => {
                        const target = $(event.target);
                        const aid = target.data('aid') || target.parent().data('aid');
                        if (aid !== undefined) {
                            const pid = target.data('pid') || target.parent().data('pid');
                            location.href = `/list.html?dirId=${aid}&pid=${pid}`;
                        }
                    });

                $('[data-sort-data=modified_time]').click();
            }

            eventInit();

            createSearch(prods);


            let aid = window.location.search.match(/(?:^|\?|&)aid=(.*?)(?:&|$)/);
            if (aid != null) {
                aid = aid[1];
                // 更新浏览量
                updateScan(aid).always(() => {
                    getArticleInfo(aid).then((res) => {
                        $('.article_list_box').html(template('article_detail_template', res.articleInfo));
                        detailIframeTpl.tpl($('.log_content').children(':first'), res.articleInfo.content);
                    }).always(() => {
                        nextPrevArticle(aid).then((res) => {
                            $('.article_pre_next').html(template('prev_next_template', res.data));
                        });
                    });
                });
            }

        }
    };

    function insideOutside() {

        const radios = ['#radio1', '#radio2'];

        let cookieId = '';
        $.each(radios, (index, radio) => {
            if ($(radio).val() == getCookie('radioCheck')) {
                $(radio).attr('checked', 'checked');
                cookieId = radio;
            }
        });
        if (!cookieId && $(radios[0]).length > 0) {
            setCookie('radioCheck', $(radios[0]).val());
            $(radios[0]).attr('checked', 'checked');
        }

        $(document).on('change', '#radio1, #radio2', function () {
            setCookie('radioCheck', $(this).val());
            window.location.reload();
        });

        if (window.location.href.indexOf('log_detail.html') === -1 && (cookieId == '' || cookieId == radios[0])) {
            main.init();
            $('.outside').empty();
        } else {
            outside.init(false);
            $('.inside').empty();
            $('.outside').css('display', 'block');
        }

        $('.radio-list-inside').css('display', 'block');

    }

    function setCookie(name, value) {
        const Days = 1;
        const exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()}`;
    }

    function getCookie(name) {
        let arr, 
reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
        if (arr = document.cookie.match(reg)) { return unescape(arr[2]); }
        return null;
    }

    main.getloginName().then((res) => {

        if (res.inside) {
            insideOutside();
        } else {
            outside.init(res.inside);
            $('.inside').empty();
            $('.outside').css('display', 'block');
        }

    })
});




// WEBPACK FOOTER //
// ./src/js/log.js